import React from "react";
import { connect } from "dva";
import { SecurePassAutoSend, SecurePassAutoSendMap } from "@/utils/enum";
import { formatPrice } from "@/utils/utils";

const SecurePassLabel = ({ securePassEnabled, securePassThreshold, securePassValue }) => {
  const threshold = formatPrice(securePassThreshold, "en-US", "USD", 0);

  if (!securePassEnabled) return null;

  if (!securePassValue) return "Not Set";

  if (securePassValue === SecurePassAutoSend.DEFAULT) {
    return <span>Use for High Value Vehicles ({threshold})</span>;
  }

  return <span>{SecurePassAutoSendMap[securePassValue]}</span>;
};

export default connect(({ configs }) => ({
  securePassEnabled: configs.securePass?.enabled,
  securePassThreshold: configs.securePass.threshold,
}))(SecurePassLabel);
